import LoadingSpinner from '@carvana/loading-spinner';
import React from 'react';
import { Card as StyledCard } from './Card.styles';

type OwnProps = React.PropsWithChildren<{
  className?: string;
  isLoading: boolean;
  isLongCard?: boolean;
}>;

export default function CommonCard({
  children,
  className,
  isLoading,
  isLongCard = false,
}: OwnProps) {
  return (
    <StyledCard
      className={className}
      isLoading={isLoading}
      isLongCard={isLongCard}
    >
      {isLoading && <LoadingSpinner className="absolute h-full" />}
      {children}
    </StyledCard>
  );
}
